export default class Physician {
  physicianId?: number | null;
  legacyPhysicianId?: number | null;
  npi?: string | null;
  displayName?: string | null;
  firstName?: string | null;
  lastName?: string | null;

  public constructor(params: Physician = {} as Physician) {
    let {
      physicianId = 0,
      legacyPhysicianId = null,
      npi = null,
      displayName = null,
      firstName = null,
      lastName = null,
    } = params;
    this.physicianId = physicianId;
    this.legacyPhysicianId = legacyPhysicianId;
    this.npi = npi;
    this.displayName = displayName;
    this.firstName = firstName;
    this.lastName = lastName;
  }
}
